import { GraphQLClient } from 'graphql-request'
import { getToken } from './auth'

// Single GraphQL client. Attaches the Bearer token (if any) on each request so the same
// client works for both authenticated and public queries.
// graphql-request v7 runs `new URL(endpoint)` internally, which rejects a bare path like
// "/graphql" — so the endpoint must be absolute.
const endpoint =
  typeof window !== 'undefined' ? `${window.location.origin}/graphql` : '/graphql'

export const gqlClient = new GraphQLClient(endpoint, {
  requestMiddleware: (request) => {
    const token = getToken()
    return {
      ...request,
      headers: {
        ...request.headers,
        // Spreading request.headers drops graphql-request's default Content-Type (it's a
        // Headers-like object, not a plain object), and without it fetch falls back to
        // text/plain, which Rails won't parse into params — so set it back explicitly.
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  },
})

// The extension calls this at startup to point the shared client at the app's absolute
// API origin (the content script runs on suno.com, so a relative path won't resolve).
export function configureGraphqlEndpoint(url: string): void {
  gqlClient.setEndpoint(url)
}

export function gql<T>(query: string, variables?: Record<string, unknown>): Promise<T> {
  return gqlClient.request<T>(query, variables)
}
